<template>
  <b-dropdown
    id="dropdown-grouped"
    variant="outline-secondary"
    class="dropdown-language"
    right
    size="sm"
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="$i18n.locale = localeObj.locale"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem, BImg } from 'bootstrap-vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      {
        locale: 'gr',
        img: require('@/assets/images/flags/gr.png'),
        name: 'Greek',
      },
      {
        locale: 'fr',
        img: require('@/assets/images/flags/fr.png'),
        name: 'French',
      },
      {
        locale: 'de',
        img: require('@/assets/images/flags/de.png'),
        name: 'German',
      },
      {
        locale: 'es',
        img: require('@/assets/images/flags/es.png'),
        name: 'Spanish',
      },
      {
        locale: 'it',
        img: require('@/assets/images/flags/it.png'),
        name: 'Italian',
      },
      // {
      //   locale: 'pt',
      //   img: require('@/assets/images/flags/pt.png'),
      //   name: 'Portuguese',
      // },
      {
        locale: 'pl',
        img: require('@/assets/images/flags/pl.png'),
        name: 'Polish',
      },
      {
        locale: 'ro',
        img: require('@/assets/images/flags/ro.png'),
        name: 'Romanian',
      },
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
}
</script>

<style>

</style>
